module.exports = __webpack_public_path__ + "static/media/19-min.jpg.587f2fa5.webp";